<template>
  <div name="modal" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editModalLabel">{{ title }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="closeModal()">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <div class="form-row">
                  <label for="cW" class="col col-form-label">Current value:</label>
                  <div class="col col-form-label"><div id="cW" ><strong>{{ currentShelf }}</strong></div></div>
                </div>
                <div class="form-row">
                  <label for="nW" class="col col-form-label">New value:</label>
                  <input class="col form-control form-control-lg" ref="nw" type="text" id="nW" v-model="newValue" placeholder="" autocomplete="off" @keyup.enter="saveModalShelf(title, newValue, ipropert)">
                </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal()" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" @click="saveModalShelf(title, newValue, ipropert)">Save changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'ProductEditShelf',

    data () {
      return {
        newValue: null
      }
    },

    mounted () {
      this.$refs.nw.focus()
    },

    props: ['title', 'currentShelf', 'ipropert'],

    methods: {
      ...mapActions(['updateAdaptixShelf']),
      closeModal (response) {
        this.$emit('statusModal', [false, response])
      },
      saveModalShelf (title, newValue, ipropert) {
        this.$store.dispatch('updateAdaptixShelf', { title, newValue, ipropert })
          .then(response => {
            this.closeModal(response)
          })
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductEditShelf.vue